/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_BARCODE_LOOKUP_RECEIVE,
    CURRENT_BARCODE_LOOKUP_REQUEST,
    CURRENT_BARCODE_LOOKUP_REQUEST_SUCCESS,
    CURRENT_BARCODE_LOOKUP_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_BARCODE_LOOKUP_REQUEST]: () => true,
    [CURRENT_BARCODE_LOOKUP_REQUEST_SUCCESS]: () => false,
    [CURRENT_BARCODE_LOOKUP_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_BARCODE_LOOKUP_RECEIVE]: (state, action) => action.payload.barcodelookup,
});

export const error = createReducer(false, {
    [CURRENT_BARCODE_LOOKUP_REQUEST]: () => false,
    [CURRENT_BARCODE_LOOKUP_REQUEST_SUCCESS]: () => false,
    [CURRENT_BARCODE_LOOKUP_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
